import { LogStream } from '../components/admin/LogStream';

export function AdminStream() {
  return <LogStream />;
}
